import React from "react";
import styled from "styled-components";
import guaranteedDeparture from "../icons/guaranteed-departure.svg";

const GuaranteedDeparture = props => {
  return (
    <Container title="Guaranteed Departure">
      <Image src={guaranteedDeparture} alt="" />
    </Container>
  );
};

export const Container = styled.div`
  width: 1.3rem;
  height: 1.3rem;
  margin-left: 5px;
`;

export const Image = styled.img`
  display: block;
  height: 100%;
  width: 100%;
`;

export default GuaranteedDeparture;
